module.exports = __webpack_public_path__ + "img/housetypedefault.ae675650.png";